import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import s from './HeroSection.module.css';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
    OptimizedMotion,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import { motion } from 'framer-motion';

import dashboard from './images/Quick post generated.svg';
import StartButton from '../shared/start-button/StartButton';

const HeroSection = () => {
    const navigate = useNavigate();

    const handleRequestDemo = () => {
        navigate('/auth');
    };

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);

    return (
        <div className={s.container}>
            <div className={s.flexRow}>
                <div className={s.topContent}>
                    {/* Floating Feature Bubbles */}
                    <motion.div
                        className={s.featureBubble}
                        style={{ top: '20%', left: '4%' }}
                        initial={{ opacity: 0, y: 20, rotate: -7 }}
                        animate={{ opacity: 1, y: 0, rotate: -7 }}
                        transition={{ duration: 0.6, delay: 0.8 }}
                    >
                        <span className={s.bubbleEmoji}>🎯</span>
                        <span className={s.bubbleText}>Brand-voice intelligence</span>
                    </motion.div>

                    <motion.div
                        className={s.featureBubble}
                        style={{ top: '15%', right: '3%' }}
                        initial={{ opacity: 0, y: 20, rotate: 5 }}
                        animate={{ opacity: 1, y: 0, rotate: 5 }}
                        transition={{ duration: 0.6, delay: 1.0 }}
                    >
                        <span className={s.bubbleEmoji}>🤝</span>
                        <span className={s.bubbleText}>Collaborative workspace</span>
                    </motion.div>

                    <motion.div
                        className={s.featureBubble}
                        style={{ bottom: '10%', left: '5%' }}
                        initial={{ opacity: 0, y: 20, rotate: 5 }}
                        animate={{ opacity: 1, y: 0, rotate: 5 }}
                        transition={{ duration: 0.6, delay: 1.2 }}
                    >
                        <span className={s.bubbleEmoji}>⚙️</span>
                        <span className={s.bubbleText}>Workflow automation</span>
                    </motion.div>

                    <motion.div
                        className={s.featureBubble}
                        style={{ bottom: '20%', right: '8%' }}
                        initial={{ opacity: 0, y: 20, rotate: -5 }}
                        animate={{ opacity: 1, y: 0, rotate: -5 }}
                        transition={{ duration: 0.6, delay: 1.4 }}
                    >
                        <span className={s.bubbleEmoji}>📊</span>
                        <span className={s.bubbleText}>Performance analytics</span>
                    </motion.div>

                    <OptimizedMotionH1 className={s.title} type="slide-left" delay={0.2}>
                        The Power of SimpleeCreate
                    </OptimizedMotionH1>

                    <OptimizedMotionP className={s.subtitle} type="slide-left" delay={0.4}>
                        Explore AI-driven workflows, brand-voice consistency, and collaborative
                        publishing all in one place.
                    </OptimizedMotionP>

                    <StartButton className={s.startBtn} />
                </div>

                <div className={s.bottomContent}>
                    <img src={dashboard} alt="" className={s.containerImg} />
                </div>
            </div>
        </div>
    );
};

export default HeroSection;
